import React, {useContext, useEffect, useState} from 'react';
import {AgilAuthProvider, useAgilAuth} from './context/provider';
import jwtService from './services/jwtService'



const withAuthProvider = (Component) => {
    return (props) => {
        return(
            <AgilAuthProvider>
                <Component {...props}/>
            </AgilAuthProvider>
        )
    }
}


const AgilAuth = (props) => {
    const {
        children
    } = props;

    const [waitingForService, setWaitingForService] = useState(true);
    const {validateToken, loginWithToken} = useAgilAuth();

    useEffect(() => {
        console.log("Ejecutando esto")
        checkJWT().then();
    }, [])

    const checkJWT = async () => {
        jwtService.on('onAutoLogin', (token) => {
            console.log("Desde JWT", token)
            // exite token y esta listo para loguearse automaticamente
            console.log("AGIL-AUTH : onAutoLogin")
            loginWithToken(token).then(() => {
                setWaitingForService(false);
            }).catch(() => {
                setWaitingForService(false);
            })
        });

        jwtService.on('onAutoLogout', message => {
            // Se autodesloguea
            console.log("AGIL-AUTH : onAutoLogout")
            setWaitingForService(false);
        });

        jwtService.on('onNoAccessToken', () => {
            // No se encontro token
            console.log("AGIL-AUTH : onNoAccessToken")
            setWaitingForService(false);
        });

        jwtService.init();
    }

    return (
        <>
            {!waitingForService&&children}
        </>
    )
}

export default withAuthProvider(AgilAuth);
